import { render, staticRenderFns } from "./Questionnaire.vue?vue&type=template&id=ade80c3a"
import script from "./Questionnaire.vue?vue&type=script&lang=js"
export * from "./Questionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports